import React from 'react';
import { CheckIcon, InfoIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { transformationStories, transformationPillars } from '../data/content';
export function TransformationSection() {
  return <section className="w-full bg-brand-deep px-4 py-12 sm:px-6 sm:py-20" data-id="element-124" data-mp="2wwce2bxz70zq">
      <div className="mx-auto max-w-5xl" data-id="element-125" data-mp="2rzc8s38ya29o">
        <div className="mx-auto max-w-3xl text-center" data-id="element-126" data-mp="2ryayi0zrdjt0">
          <h2 className="font-display text-[1.6rem] font-extrabold uppercase leading-tight tracking-tight text-white sm:text-4xl" data-id="element-127" data-mp="2nx7hhb5z5hq7">
            No se trata solo de comer menos.{' '}
            <span className="text-accent" data-id="element-128" data-mp="2e6wblj2qcygo">
              Se trata de empezar desde la base.
            </span>
          </h2>
          <p className="mx-auto mt-3 max-w-xl text-[0.95rem] leading-relaxed text-violet-200 sm:mt-4 sm:text-lg" data-id="element-129" data-mp="2994bi1rxm61e">
            Alimentación, glucosa, descanso, horarios y hábitos forman parte de
            una misma estrategia.
          </p>
        </div>

        <ul className="mt-8 grid gap-4 sm:mt-10 sm:grid-cols-2" data-id="element-130" data-mp="209r2193t5hgo">
          {transformationStories.map(story => <li key={story.nombre} className="flex h-full flex-col overflow-hidden rounded-2xl border border-white/15 bg-white/5" data-id="element-131" data-mp="k1izuz7rjv48">
              <div className="relative bg-black/25" data-id="element-132" data-mp="5b1vp83qur3n">
                <img src={story.imagen} alt={story.alt} loading="lazy" className="mx-auto h-52 w-full object-contain sm:h-60" data-id="element-133" data-mp="ad108lb7zu26" />
                <span className="absolute left-3 top-3 rounded-full bg-black/55 px-2.5 py-1 font-display text-[0.6rem] font-extrabold uppercase tracking-wider text-white backdrop-blur-sm" data-id="element-134" data-mp="130506bvghi73">
                  Imagen ilustrativa
                </span>
              </div>

              <div className="flex flex-1 flex-col p-4 text-left sm:p-5" data-id="element-135" data-mp="39quyk4isvvep">
                <span className="w-fit rounded-full bg-accent/15 px-2.5 py-1 font-display text-[0.65rem] font-extrabold uppercase tracking-wider text-accent" data-id="element-136" data-mp="3dsg8bh01ftko">
                  {story.enfoque}
                </span>
                <p className="mt-3 text-[0.9rem] leading-relaxed text-violet-100 sm:text-base" data-id="element-137" data-mp="1factdeo5sx45">
                  “{story.relato}”
                </p>
                <p className="mt-auto pt-4 font-display text-sm font-extrabold text-white" data-id="element-138" data-mp="1aicttnc04683">
                  {story.nombre}
                  <span className="font-sans text-xs font-medium text-violet-300" data-id="element-139" data-mp="11jhr4l861e9j">
                    {' '}
                    · {story.edad} · {story.pais}
                  </span>
                </p>
              </div>
            </li>)}
        </ul>

        <p className="mx-auto mt-5 flex max-w-2xl items-start gap-2 rounded-xl border border-white/15 bg-white/5 px-4 py-3 text-left text-xs leading-relaxed text-violet-200 sm:text-sm" data-id="element-140" data-mp="rlk39yu7xjhg">
          <InfoIcon className="mt-0.5 h-4 w-4 shrink-0 text-violet-300" aria-hidden="true" data-id="element-141" data-mp="2ly1gsep9958w" />
          <span data-id="element-142" data-mp="2gy5csfgk5dtc">
            Historias e imágenes ilustrativas. No representan resultados de
            clientes de Metabolismo Reset. Los resultados individuales pueden
            variar.
          </span>
        </p>

        <div className="mx-auto mt-10 max-w-2xl border-t border-white/15 pt-8 text-center sm:mt-12" data-id="element-143" data-mp="2y9kddg7hrpwj">
          <h3 className="font-display text-[1.4rem] font-extrabold uppercase leading-tight text-white sm:text-3xl" data-id="element-144" data-mp="338dudilzlz1g">
            No necesitas otra dieta. Necesitas reiniciar la base.
          </h3>

          <ul className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-145" data-mp="2ajzropjyeejk">
            {transformationPillars.map(pillar => <li key={pillar} className="flex items-center gap-1.5 rounded-full border border-white/15 bg-white/5 px-3 py-1.5 text-xs font-medium text-violet-100 sm:text-sm" data-id="element-146" data-mp="2fit8oryg8noh">
                <CheckIcon className="h-3.5 w-3.5 shrink-0 text-accent" aria-hidden="true" data-id="element-147" data-mp="3qxgc0qgmfrvy" />
                {pillar}
              </li>)}
          </ul>

          <div className="mx-auto mt-7 max-w-md sm:mt-8" data-id="element-148" data-mp="18p582ss6d1ht">
            <CtaButton href="#precio" location="transformacion" data-id="element-149" data-mp="13qk90wonsnuy">
              Quiero conocer Metabolismo Reset
            </CtaButton>
          </div>
        </div>
      </div>
    </section>;
}